
export interface PayloadTemplate {
  SourceId: string;
  RequestDate: string;
  Price: string;
  Stock: string;
  Debug: string;
  PartnerResponses: string;
  Product: Array<{
    Index: string;
    CustomerNumber: string;
    SupplierProductNumber: string;
    Manufacturer: string;
    ManufacturerProductNumber: string;
    Quantity: number;
  }>;
}

export function getDefaultPayload(clientId: string): PayloadTemplate {
  return {
    SourceId: clientId,
    RequestDate: new Date().toISOString(),
    Price: "1",
    Stock: "1",
    Debug: "1",
    PartnerResponses: "0",
    Product: [
      {
        Index: "1",
        CustomerNumber: "0",
        SupplierProductNumber: "0",
        Manufacturer: "DIA",
        ManufacturerProductNumber: "0,0",
        Quantity: 1,
      },
    ],
  };
}
